'use client'

import { useCallback, useEffect, useRef, useState } from 'react'
import { useMutationObserver } from 'ahooks'

type TReviewTotalWidgetProps = {
  productId: number
}

/**
 * review total widget
 */
const ReviewTotalWidget = ({ productId }: TReviewTotalWidgetProps) => {
  const [urlPath, setUrlPath] = useState('')
  const reviewRef = useRef<HTMLDivElement>(null)

  const scrollToReview = useCallback(() => {
    const el = document.getElementById('reviews')
    if (el) {
      el.click()
    }
  }, [])

  useMutationObserver(
    (mutationsList) => {
      if (mutationsList.length) {
        const el = document.querySelector('.yotpo-bottomline.star-clickable')
        el?.addEventListener('click', scrollToReview)
      }
    },
    reviewRef,
    { childList: true },
  )

  useEffect(() => {
    const el = document.querySelector('.yotpo-bottomline.star-clickable')

    setUrlPath(window.location.origin + window.location.pathname)

    return () => {
      el?.removeEventListener('click', scrollToReview)
    }
  }, [scrollToReview])

  if (!urlPath) {
    return null
  }

  return (
    <div className="mt-6 xl:mt-9">
      <div
        ref={reviewRef}
        className="yotpo bottomLine bottomline-position yotpo-product-review"
        data-product-id={productId}
        data-url={urlPath}></div>
    </div>
  )
}

export default ReviewTotalWidget
